import $ from 'jquery'
import lozad from 'lozad';
import Swiper, { Autoplay, Controller, EffectFade, Navigation, Thumbs, Pagination } from 'swiper';
Swiper.use([EffectFade, Autoplay, Navigation, Thumbs, Controller, Pagination]);

export class MessageBar {
	constructor(el) {
		this.el = el;
	}

	init() {
		new Swiper(this.el, {
			spaceBetween: 0,
			effect: 'fade',
			allowTouchMove: false,
			simulateTouch: false,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
		});
	}

	promotionBar(container) {
		new Swiper(container, {
			slidesPerView: 1,
			speed: 800,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
		});

		function setHeaderSpacing() {
			if ($(window).width() < 768) {
				let headerTopBar = $('.headline-bar').outerHeight(),
					headerHeight = $('.nav-mobile').outerHeight();

				$('.nav-mobile').css('padding-top', `${headerTopBar + 17}px`);
				headerHeight = $('.nav-mobile').outerHeight();
				$('main').css('margin-top', `${headerHeight - 2}px`);
			}
		}

		setHeaderSpacing();

		$(window).on('resize', () => {
			setHeaderSpacing();
		});

		if ($('.headline-bar').length) {
			$('body').addClass('notifcationbar-on');
		}
	}
}

export class HeroCarousel {
	constructor() {
		this.init()
	}

	init() {
		if ($('#hero-slider .swiper-slide').length > 1) {
			new Swiper('#hero-slider', {
				slidesPerView: 1,
				autoHeight: true,
				speed: 800,
				effect: 'fade',
				fadeEffect: {
					crossFade: 'true'
				},
				autoplay: {
					delay: 2000,
					pauseOnMouseEnter: false,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.hero-slider-pagination',
					type: 'bullets',
					clickable: true
				},
				breakpoints: {
					992: {
						autoHeight: false
					}
				},
				on: {
					afterInit: (swiper) => {
						const observer = lozad();
						observer.observe();
					}
				}
			})
		}
	}
}

export class PdpGallery {
	constructor(gallery, thumb) {
		this.gallery = gallery;
		this.thumb = thumb;
		window.innerWidth <= 1023.8 && this.init();
	}

	init() {
		var galleryThumbs = new Swiper(this.thumb, {
			threshold: 10,
			freeMode: true,
			loop: true,
			slidesPerView: 4,
			spaceBetween: 12,
			watchSlidesProgress: true,
			breakpoints: {
				320: {
					spaceBetween: 27,
				},
				992: {
					spaceBetween: 12,
					slidesPerView: 5,
				},
			},
		});

		

		new Swiper(this.gallery, {
			spaceBetween: 12,
			loop: true,
			pagination: {
				el: '#pdpGallery .swiper-pagination',
				type: 'bullets',
				clickable: true
			}
		});
	}

	giftCarousel(gallery, thumbs) {
		let isLoop = false,
			thumbWrapper = document.querySelector(thumbs);
		if (thumbWrapper) {
			thumbWrapper = thumbWrapper.querySelector('.swiper-wrapper');
		}

		var galleryTop = new Swiper(gallery, {
			spaceBetween: 12,
			resizeObserver: true,
			centeredSlides: true,
			watchSlidesProgress: true,
			navigation: {
				nextEl: '.pdp-carousel__nav--next',
				prevEl: '.pdp-carousel__nav--prev',
			},
			loop: isLoop,
			loopedSlides: 50,
			on: {
				beforeInit: () => {
					let container = document.querySelector(gallery),
						childElementLength = container.querySelectorAll('.swiper-slide').length;

					if (window.innerWidth > 992) {
						if (childElementLength > 5) {
							isLoop = true;
						} else {
							thumbWrapper.classList.add('swiper-wrapper--center');
						}
					} else {
						if (childElementLength > 4) {
							isLoop = true;
						} else {
							thumbWrapper.classList.add('swiper-wrapper--center');
						}
					}
				},
			},
		});

		var galleryThumbs = new Swiper(thumbs, {
			spaceBetween: 12,
			centeredSlides: true,
			centerInsufficientSlides: true,
			watchOverflow: true,
			width: 63,
			slidesPerView: 'auto',
			touchRatio: 0.2,
			slideToClickedSlide: true,
			loop: isLoop,
			loopedSlides: 50,
			breakpoints: {
				320: {
					spaceBetween: 27,
				},
				992: {
					spaceBetween: 12,
				},
			},
		});
		galleryTop.controller.control = galleryThumbs;
		galleryThumbs.controller.control = galleryTop;
	}
}

export class TreatmentCarousel {
	constructor(el) {
		this.el = el;
	}

	init() {
		new Swiper(this.el, {
			loop: true,
			slidesPerView: 3,
			spaceBetween: 48,
			watchOverflow: true,
			navigation: {
				nextEl: '.treatment-button--next',
				prevEl: '.treatment-button--prev',
			},
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 1,
					spaceBetween: 30,
				},
				768: {
					slidesPerView: 2,
				},
				// when window width is >= 480px
				1200: {
					slidesPerView: 3,
					spaceBetween: 10,
				},
				// when window width is >= 640px
				1440: {
					spaceBetween: 48,
				},
			},
		});
	}
}
